import { applyFontWeightSemiBold, highContrastForeground, neutralForegroundRest, } from "@microsoft/fast-components-styles-msft";
import { applyFocusVisible, directionSwitch, toPx } from "@microsoft/fast-jss-utilities";
import { black, white } from "../utilities/colors";
const attributionHeight = 22;
const centeredInlineFlex = {
    display: "inline-flex",
    "align-items": "center",
};
const styles = {
    previewCard: {
        position: "relative",
        overflow: "hidden",
        display: "flex",
        "flex-direction": "row",
        "&:hover": {
            "& $previewCard_headingContent": {
                "text-decoration": "underline",
            },
            "& $previewCard_imageRegion": {
                "&$previewCard_obscuredRegion $previewCard_image": {
                    opacity: ".9",
                },
            },
        },
    },
    previewCard_attribution: Object.assign({}, centeredInlineFlex, { "box-sizing": "border-box", "align-self": "flex-end", width: "100%", "z-index": "0", "max-height": toPx(attributionHeight) }),
    previewCard_contentRegion: {
        display: "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
        flex: "2",
        order: "2",
        "margin-left": directionSwitch("8px", ""),
        "margin-right": directionSwitch("", "8px"),
    },
    previewCard_heading: Object.assign({ display: "block", "text-decoration": "none", transition: "all .2s ease-in-out", "&::after": {
            top: "0",
            right: "0",
            "z-index": "1",
        } }, applyFocusVisible("& $previewCard_headingContent", {
        "text-decoration": "underline",
    })),
    previewCard_headingContent: Object.assign({}, applyFontWeightSemiBold(), { display: "-webkit-box", "-webkit-line-clamp": "2", "-webkit-box-orient": "vertical" }),
    previewCard_imageRegion: {
        position: "relative",
        display: "inline-flex",
        background: neutralForegroundRest(() => white),
        order: "1",
    },
    previewCard_image: {
        opacity: "1",
    },
    previewCard_icon: Object.assign({ width: "16px", height: "16px", fill: white }, highContrastForeground),
    previewCard_iconWrapper: Object.assign({ position: "absolute" }, centeredInlineFlex, { "justify-content": "center", background: black, opacity: "0.4", bottom: "0", width: "24px", height: "24px", right: directionSwitch("0", ""), left: directionSwitch("", "0") }),
    previewCard_obscuredRegion: {
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: "0",
            left: "0",
        },
    },
    previewCard_positioningRegion: {
        height: "100%",
        display: "flex",
        "flex-direction": "row",
    },
};
export default styles;
